module.exports = (__webpack_require__(0))(41);


//////////////////
// WEBPACK FOOTER
// delegated ./src/models/AccessControlledModel.js from dll-reference girder_lib
// module id = 47
// module chunks = 0